
















import { Component, Vue, Prop } from "vue-property-decorator";
import { GetProjectDetail } from "@/request/projects";

@Component({})
export default class ProjectComposeHeader extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private title: any;
  private project: any = {};
  private get ifCompose() {
    return !this.$store.state.researchListComposeDiabled;
  }
  /**
   * @description 返回项目列表
   */
  private goToList() {
    this.$router.push("/main/project/research-list-folder/" + this.projectId);
  }
  /**
   * @description 开始编辑
   */
  private startCompose() {
    this.$store.commit("updateResearchListComposeDiabled", false);
  }
  /**
   * @description 初始化获得项目详情
   */
  private mounted() {
    GetProjectDetail(this, this.projectId).then((data: any) => {
      this.project = data;
    });
  }
}
